/* tslint:disable */
/* eslint-disable */
/**
 * Workflow service API
 * Service for workflow management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SupervisorRejectsOrgDto
 */
export interface SupervisorRejectsOrgDto {
    /**
     * Created or processed Workflow instance Id
     * @type {string}
     * @memberof SupervisorRejectsOrgDto
     */
    workflowInstanceId: string;
    /**
     * User Id
     * @type {string}
     * @memberof SupervisorRejectsOrgDto
     */
    userId: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SupervisorRejectsOrgDto
     */
    errorList?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof SupervisorRejectsOrgDto
     */
    note?: string;
}

/**
 * Check if a given object implements the SupervisorRejectsOrgDto interface.
 */
export function instanceOfSupervisorRejectsOrgDto(value: object): boolean {
    if (!('workflowInstanceId' in value)) return false;
    if (!('userId' in value)) return false;
    return true;
}

export function SupervisorRejectsOrgDtoFromJSON(json: any): SupervisorRejectsOrgDto {
    return SupervisorRejectsOrgDtoFromJSONTyped(json, false);
}

export function SupervisorRejectsOrgDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SupervisorRejectsOrgDto {
    if (json == null) {
        return json;
    }
    return {
        
        'workflowInstanceId': json['workflowInstanceId'],
        'userId': json['userId'],
        'errorList': json['errorList'] == null ? undefined : json['errorList'],
        'note': json['note'] == null ? undefined : json['note'],
    };
}

export function SupervisorRejectsOrgDtoToJSON(value?: SupervisorRejectsOrgDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'workflowInstanceId': value['workflowInstanceId'],
        'userId': value['userId'],
        'errorList': value['errorList'],
        'note': value['note'],
    };
}

